var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 29,
    viewBox: "0 0 41 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9485 26.68C13.3421 28.2267 11.3048 29 8.83647 29C6.40734 29 4.48754 28.1107 3.07708 26.332C1.66661 24.5533 0.961379 21.3827 0.961379 16.82C0.961379 12.2187 4.01738 6.612 10.1294 2.60967e-06L15.4186 3.77C13.4597 7.55934 12.2255 10.7687 11.7162 13.398C13.4009 13.9393 14.7722 14.906 15.83 16.298C16.8487 17.69 17.358 19.3913 17.358 21.402C17.358 23.374 16.5548 25.1333 14.9485 26.68ZM37.6922 26.622C36.125 28.1687 34.1269 28.942 31.6977 28.942C29.2686 28.9807 27.3488 28.1107 25.9383 26.332C24.5279 24.5533 23.8226 21.3633 23.8226 16.762C23.8226 12.122 26.8395 6.53467 32.8731 6.255e-07L38.2799 3.77C36.2034 7.40467 34.9692 10.614 34.5774 13.398C36.223 13.9393 37.5551 14.906 38.5737 16.298C39.5532 17.6513 40.043 19.256 40.043 21.112C40.043 21.1893 40.043 21.7307 40.043 22.736C40.043 23.78 39.2594 25.0753 37.6922 26.622Z",
    fill: "#FB3F6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.13155b889e36f9b461b9a4eeb8202fb5.svg";
export { ForwardRef as ReactComponent };